import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

class SortableTh extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    const newDirection = this.props.direction === 'asc' ? 'desc' : 'asc'

    this.props.onSortByChange(this.props.attribute, newDirection)
  }

  render() {
    return (
      <th
        className={`${this.props.className} is-sortable`}
        onClick={this.onClick}
      >
        <div className="dropable-row__content">
          { this.props.direction === 'desc' && <Icon type="arrow-up" /> }
          { this.props.direction === 'asc' && <Icon type="arrow-down" /> }
          { !this.props.direction && <Icon type="arrow-down" className="is-not-active" /> }

          {this.props.children}
        </div>
      </th>
    )
  }
}

export default SortableTh

SortableTh.propTypes = {
  direction: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]).isRequired,
  attribute: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
}
